/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Environment } from "../../../Config/constants";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { ICreateSellersPayload, IListSellersPayload, ISellerEntity, IUpdateSellersPayload } from "./sellers.interface";
import { ISellersListResponse } from "./sellers.interface";

export class SellersApiRemoteService {
  constructor(private service: AxiosInstance) {}

//   public destroy = async (customerId: string): Promise<Result<void>> => {
//     try {
//         const response = await this.service.delete(`/customers/${customerId}`);

//       return Result.ok(response.data);
//     } catch (error: any) {
//       return Result.fail(error?.response?.data ?? error);
//     }
//   };

  public update = async ({ id, ...rest }: IUpdateSellersPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.put(`/seller/${id}`, {...rest} );

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async ({ page, searchBy}: IListSellersPayload): Promise<Result<ISellersListResponse>> => {
    try {
        const response = await this.service.get(`/sellers`, { params: { 
          offset: Number(Environment.OFFSET_REGISTERS),
          page,
          searchBy,
        }});

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public show = async (sellerId: string): Promise<Result<ISellerEntity>> => {
    try {
        const response = await this.service.get(`/seller/${sellerId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: ICreateSellersPayload): Promise<Result<ISellerEntity>> => {
    try {
        const response = await this.service.post(`/seller`, data);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  

//   public update = async (data: IUpdateCustomerPayload): Promise<Result<void>> => {
//     try {
//         const response = await this.service.put(`/customers/${data.id}`, data );

//       return Result.ok(response.data);
//     } catch (error: any) {
//       return Result.fail(error?.response?.data ?? error);
//     }
//   };
}
